import { render, staticRenderFns } from "./allIdentitiesData.vue?vue&type=template&id=1fb76111&scoped=true"
import script from "./allIdentitiesData.vue?vue&type=script&lang=js"
export * from "./allIdentitiesData.vue?vue&type=script&lang=js"
import style0 from "./allIdentitiesData.vue?vue&type=style&index=0&id=1fb76111&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb76111",
  null
  
)

export default component.exports